import {
  AfterViewInit,
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  EventEmitter,
  Input,
  Output,
  QueryList,
  ViewChildren,
} from '@angular/core';
import { ContractTypeOption } from '@immosky/types';
import { FocusKeyManager, FocusOrigin } from '@angular/cdk/a11y';
import { ListButtonDirective } from '../../directives/list-button.directive';
import { I18nService } from '@immosky/shared';

@Component({
  selector: 'lib-contract-type-switch',
  templateUrl: './contract-type-switch.component.html',
  styleUrls: ['./contract-type-switch.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ContractTypeSwitchComponent implements AfterViewInit {
  tabIndex = 0;
  focusKeyManager!: FocusKeyManager<ListButtonDirective>;

  @Input()
  options: ContractTypeOption[] = [];

  @Input()
  currentOption!: ContractTypeOption;

  @ViewChildren(ListButtonDirective)
  buttons!: QueryList<ListButtonDirective>;

  @Output()
  update = new EventEmitter<ContractTypeOption>();

  constructor(
    private cdRef: ChangeDetectorRef,
    private i18nService: I18nService
  ) {}

  ngAfterViewInit(): void {
    this.focusKeyManager = new FocusKeyManager<ListButtonDirective>(
      this.buttons
    )
      .withWrap()
      .withHomeAndEnd()
      .withVerticalOrientation()
      .withHorizontalOrientation('ltr');
  }

  onFocus() {
    this.focusKeyManager.setActiveItem(this.getIndexOfCurrentOption());
  }

  onFocusChange(event: FocusOrigin) {
    if (event) {
      this.tabIndex = -1;
    } else {
      this.tabIndex = 0;
    }
    this.cdRef.detectChanges();
  }

  onKeydown(event: KeyboardEvent) {
    this.focusKeyManager.onKeydown(event);
  }

  select(option: ContractTypeOption) {
    this.update.emit(option);
  }

  private getIndexOfCurrentOption(): number {
    return this.options.indexOf(this.currentOption);
  }

  trackBy(index: number, option: ContractTypeOption) {
    return option.value;
  }

  get buttonWidth() {
    let width = 0;

    switch (this.i18nService.currentLangCode) {
      case 'de':
        width = 64;
        break;
      case 'en':
        width = 64;
        break;
      case 'fr':
        width = 69;
        break;
      case 'it':
        width = 85;
        break;
    }

    return `${width}px`;
  }
}
